module.exports = __webpack_public_path__ + "images/mdj/members/common/common_bg01-3f57a2b166bf236ad420e4e39d24f772.jpg";